<section class="card shadow-sm-darker">
  <div class="card-body d-flex justify-content-between align-items-center">
    <div>
      <h3>{{assessmentname}}</h3>
      <p class="text-sm mb-0"><span>{{assessment.timedType}} / {{assessment.questionType}}</span><br>
        <span><span class="font-weight-600">Start:</span> {{assessment.startTime}}</span><br>
        <span><span class="font-weight-600">Due:</span> {{assessment.endTime}}</span><br>
        <span><span class="font-weight-600">Submitted by:</span> {{assessment.student}}</span>
        <ng-template [ngIf]="assessment.scored">
          <br>
          <span><span class="font-weight-600">Score:</span> {{assessment.score}} / {{assessment.marks}}</span>
        </ng-template>
      </p>
    </div>
    <div>
      <button *ngIf="!assessment.allowRetake" class="add-item-btn" (click)="allowRetake()">
        Allow Retake
      </button> 
      <button *ngIf="assessment.allowRetake" class="add-item-btn" (click)="allowRetake(false)">
        Disallow Retake
      </button> 
    </div>        
  </div>
</section>
<form #scorequestionanswers="ngForm" name="scorequestionanswers" class="card shadow-sm-darker mb-0">
  <div class="card-body">
    <ul class="list-unstyled m-0" #answerPane>
      <li *ngFor="let question of assessment.questions; let optionGroupIndex = index">
        <h4 class="text-xs mb-3"><span class="text-primary-darker">QUESTION {{optionGroupIndex + 1}}</span>
          of {{this.assessment.questions.length}} ({{question.marks}} mark{{question.marks === 1 ? '' : 's'}})
        </h4>
        <div class="inlineOptions innerHTML-wrap" [innerHTML]="question.text | customhtmlsanitizer">
        </div>
        <div *ngIf="this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.essayQuestionFlag"
          class="mt-3">
          <app-assessment-editor [answeredText]="question.stdAnswer" [wordLimit]="assessment.essayTextLimit" (textLimitExceeded)="handleTextExceeded($event)" [questionID]="question.id" [teacherView]="true" >
          </app-assessment-editor>
        </div>
        <div *ngIf="this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.fileQuestionFlag"
          class="mt-3">
          <section>
            <h4 class="text-uppercase">Submitted/Uploaded File</h4>
            <p *ngIf="this.fileQuestionDisplay; else noFileSubmitted"
              class="text-sm mb-0 d-flex align-items-center flex-wrap gap-.5">
              <a target="_blank" href="{{fileQuestionDisplay.link}}" class="text-link" download>
                <i class="fa fa-download mr-2"></i>{{this.fileQuestionDisplay.name}}
              </a>
              <button *ngIf="isImage || isPdf" (click)="pdfpreviewChange()" type="button"
                class="btn btn--sm m-0 p-1 text-2xs">
                <i class="fa fa-file-pdf"></i> Preview
              </button>
            </p>
            <ng-template #noFileSubmitted>
              <p class="text-sm font-italic mb-0">There Was No File Submitted</p>
            </ng-template>
          </section>
          <section *ngIf="pdfpreview" class="mt-4">
            <h5 class="text-uppercase">File Preview</h5>
            <img *ngIf="isImage" [src]="imageData" alt="Submitted Image"
              class="mw-100 rounded-md shadow-sm-darker bg-black-100">
            <div *ngIf=isPdf class="pdf-preview-window position-relative rounded-md shadow-sm-darker bg-black-100 overflow-hidden">
              <pdf-viewer [src]="pdfData" [render-text]="true"></pdf-viewer>
            </div>
          </section>
          
        </div>
        <div *ngIf="this.assessment.questionType != this.assessmentManager.QuestionTypeFlags.multichoiceQuestionFlag">
          <div class="fieldset fieldset--lg mt-5 mb-0">
            <label for="{{question.id}}" class="legend"> Score Answer <span class="requiredfield">*</span></label>
            <input class="text-field scoreInputItem" type="number" id="{{question.id}}" max="question.marks"
              value="{{question.score}}" required>       
          </div>
          <div class="fieldset fieldset--lg mt-3 mb-3">         
            <label class="legend"> Comment </label>
            <textarea class="text-field commentInputItem" style="height: 20vh; padding: 10px;" type="text" value="{{question.comment}}">
            </textarea>
          </div>
        </div>        
      </li>
    </ul>    
  </div>  
  <div class="card-footer d-flex justify-content-center flex-wrap gap-1.5">
    <button type="submit" class="btn m-0"
      *ngIf="this.assessment.questionType != this.assessmentManager.QuestionTypeFlags.multichoiceQuestionFlag"
      [disabled]="!scorequestionanswers.valid" (click)="saveAssessment()">Submit</button>
    <button type="button" class=" btn btn--warning m-0" routerLink="/user/assessmentsubmissions"
      [queryParams]="{aid : this.assessmentID, classid : this.classID, batchid: this.batchid}">Cancel</button>
  </div>
</form>
